import { KeyboardArrowDown } from "@mui/icons-material";
import { MenuItem } from "@mui/material";
import AppTextField from "components/input-fields/AppTextField";
import { useFormikContext } from "formik";
import useFetch from "hooks/useFetch";
import i18next from "i18next";
import React from "react";
import { useTranslation } from "react-i18next";
import api from "utils/api";

export default function SelectType({ disabled = false }) {
  const { t } = useTranslation();

  const { handleChange, touched, errors, values } = useFormikContext();

  const { data: types } = useFetch(
    React.useCallback(() => api.getQuestionTypes(), [])
  );

  return (
    <AppTextField
      select
      name="type"
      disabled={disabled}
      onChange={handleChange}
      sx={{ width: 200 }}
      label={t("Question.type")}
      SelectProps={{
        IconComponent: KeyboardArrowDown,
        value: values.type,
      }}
      error={Boolean(touched.type && errors.type)}
      helperText={touched.type && errors.type}
    >
      <div></div>
      {types?.map((item) => (
        <MenuItem key={item.id} value={item.id}>
          {item.question_types_trans.find(
            (m) => m.locale === i18next.language.toUpperCase()
          )?.description || ""}
        </MenuItem>
      ))}
    </AppTextField>
  );
}
